import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ProjectItemSame = Scrivito.provideObjClass("ProjectItemSame", {
  attributes: {
    ...defaultPageAttributes,
    ...metadataAttributes,
    redirectToProjectConfigurator: [
      "reference",
      { only: "ProjectConfigurator" },
    ],
    redirectAfterDelete: ["reference", { only: "ProjectListSame" }],
  },
  extractTextAttributes: ["title", "subtitle"],
});

export default ProjectItemSame;
